import React from "react";
import {ActivityIndicator, Dimensions, View} from "react-native";
import {DotIndicator} from "react-native-indicators";
import apps from "../lib/apps";

export const LoadingIndicator: React.FC<{ marginTop: number }> = ({marginTop}) => {
    return (
        <View style={{alignItems: "center", marginTop: marginTop}}>
            <DotIndicator size={5} color={apps.getAccent()}/>
        </View>
    );
};

export const SubmitIndicator: React.FC<{}> = () => {
    return (
        <ActivityIndicator size="large" color={apps.getAccent()}
                           style={{position: "absolute",
                               marginTop: Dimensions.get("screen").height / 2 - 30,
                               marginLeft: Dimensions.get("screen").width / 2 - 30}}
                            />
    );
}
